/**
 * Canonical form of a course identifier on the FE — must mirror the backend's
 * `CourseRequestHelpers.NormalizeCourseId` exactly so equality checks against
 * server-emitted normalized columns (`Assignment.normalizedCourseId`,
 * `Section.normalizedCourseId`, ...) succeed.
 *
 * Backend formula: trim + upper-invariant. Null / whitespace / undefined input
 * collapses to the empty string.
 *
 * Drift here causes silent bugs — e.g. an `EventDetailPanel` that filters its
 * roster by a lowercased course id will render zero matches against an
 * uppercased `assignment.normalizedCourseId`. Always route raw `event.courseId`
 * / `request.courseId` / similar strings through this helper before comparing.
 */
export function normalizeCourseId(courseId: string | null | undefined): string {
  return (courseId ?? "").trim().toUpperCase();
}
